/**
 * Global Phenomenon — Theme JS
 * Vanilla JS, no libraries, no animations
 * Ajax Cart functionality only
 */

(function () {
  'use strict';

  /* ---------- Cart Count Update ---------- */

  function updateCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-bag-count').forEach(function (el) {
          var countEl = el.querySelector('.cart-count');
          if (countEl) {
            countEl.textContent = cart.item_count;
          }
          el.hidden = cart.item_count < 1;
        });

        var hpBag = document.getElementById('hp-cart-link');
        if (hpBag) {
          hpBag.hidden = cart.item_count < 1;
        }

        return cart;
      })
      .catch(function (error) {
        console.error('[GP] Cart count update failed:', error);
      });
  }

  function formatMoney(cents) {
    var format = window.GP && window.GP.moneyFormat ? window.GP.moneyFormat : '${{amount}}';
    var amount = (parseInt(cents, 10) / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(parseInt(cents, 10) / 100))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function refreshCartPage(cart) {
    if (!document.getElementById('cart-page')) return;

    if (!cart.item_count) {
      window.location.reload();
      return;
    }

    cart.items.forEach(function (item) {
      var qtyEl = document.querySelector('[data-cart-qty][data-line-key="' + item.key + '"] [data-cart-qty-value]');
      if (qtyEl) {
        qtyEl.textContent = item.quantity;
      }

      var totalEl = document.querySelector('[data-cart-line-total][data-line-key="' + item.key + '"]');
      if (totalEl) {
        totalEl.textContent = formatMoney(item.final_line_price);
      }
    });

    document.querySelectorAll('[data-cart-qty][data-line-key]').forEach(function (row) {
      var key = row.getAttribute('data-line-key');
      var stillInCart = cart.items.some(function (item) { return item.key === key; });
      if (!stillInCart) {
        var line = row.closest('.cart-item');
        if (line) line.remove();
      }
    });

    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }
  }

  function changeCartQuantity(lineKey, quantity) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart update failed');
        }
        return response.json();
      })
      .then(function () {
        return fetch(root + 'cart.js', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
      })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-bag-count').forEach(function (el) {
          var countEl = el.querySelector('.cart-count');
          if (countEl) {
            countEl.textContent = cart.item_count;
          }
          el.hidden = cart.item_count < 1;
        });

        var hpBag = document.getElementById('hp-cart-link');
        if (hpBag) {
          hpBag.hidden = cart.item_count < 1;
        }

        refreshCartPage(cart);
        return cart;
      });
  }

  function initCartQuantity() {
    var cartPage = document.getElementById('cart-page');
    if (!cartPage) return;

    cartPage.addEventListener('click', function (e) {
      var minusBtn = e.target.closest('[data-cart-qty-minus]');
      var plusBtn = e.target.closest('[data-cart-qty-plus]');
      if (!minusBtn && !plusBtn) return;

      var wrap = e.target.closest('[data-cart-qty]');
      if (!wrap) return;

      var lineKey = wrap.getAttribute('data-line-key');
      var valueEl = wrap.querySelector('[data-cart-qty-value]');
      if (!lineKey || !valueEl) return;

      var currentQty = parseInt(valueEl.textContent, 10) || 0;
      var nextQty = currentQty + (minusBtn ? -1 : 1);
      if (nextQty < 0) return;

      var buttons = wrap.querySelectorAll('.cart-qty__btn');
      buttons.forEach(function (btn) { btn.disabled = true; });

      changeCartQuantity(lineKey, nextQty)
        .catch(function (error) {
          console.error('[GP] Cart quantity update failed:', error);
        })
        .finally(function () {
          buttons.forEach(function (btn) { btn.disabled = false; });
        });
    });
  }

  function getProductQuantity(button) {
    var form = button.closest('form');
    if (!form) return 1;

    var valueEl = form.querySelector('[data-product-qty-value]');
    if (!valueEl) return 1;

    var quantity = parseInt(valueEl.textContent, 10);
    return quantity > 0 ? quantity : 1;
  }

  function initProductQuantity() {
    document.querySelectorAll('[data-product-quantity]').forEach(function (wrap) {
      var valueEl = wrap.querySelector('[data-product-qty-value]');
      var minusBtn = wrap.querySelector('[data-product-qty-minus]');
      var plusBtn = wrap.querySelector('[data-product-qty-plus]');
      if (!valueEl || !minusBtn || !plusBtn) return;

      function setQuantity(nextQty) {
        var qty = Math.max(1, nextQty);
        valueEl.textContent = String(qty);
        minusBtn.disabled = qty <= 1;
      }

      minusBtn.addEventListener('click', function () {
        setQuantity((parseInt(valueEl.textContent, 10) || 1) - 1);
      });

      plusBtn.addEventListener('click', function () {
        setQuantity((parseInt(valueEl.textContent, 10) || 1) + 1);
      });

      setQuantity(parseInt(valueEl.textContent, 10) || 1);
    });
  }

  /* ---------- Ajax Add to Cart ---------- */

  function addToCart(variantId, quantity) {
    var body = JSON.stringify({
      id: variantId,
      quantity: quantity || 1
    });

    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Add to cart failed');
        }
        return response.json();
      })
      .then(function (item) {
        updateCartCount();
        return item;
      });
  }

  /* ---------- Product Form Handler ---------- */

  function initProductForms() {
    document.querySelectorAll('[data-add-to-cart]').forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        var variantId = button.getAttribute('data-variant-id');

        if (!variantId) {
          /* Check for a variant select in the same form context */
          var form = button.closest('form');
          if (form) {
            var select = form.querySelector('[name="id"]');
            if (select) {
              variantId = select.value;
            }
          }
        }

        if (!variantId) return;

        button.disabled = true;
        button.textContent = 'ADDING...';

        addToCart(parseInt(variantId, 10), getProductQuantity(button))
          .then(function () {
            button.textContent = 'ADDED';
            setTimeout(function () {
              button.disabled = false;
              button.textContent = button.getAttribute('data-label') || 'ADD TO CART';
            }, 1500);
          })
          .catch(function (error) {
            console.error('[GP] Add to cart failed:', error);
            button.disabled = false;
            button.textContent = button.getAttribute('data-label') || 'ADD TO CART';
          });
      });
    });
  }

  /* ---------- Checkout Now (Buy It Now) ---------- */

  function initCheckoutButtons() {
    document.querySelectorAll('[data-checkout-now]').forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        var variantId = button.getAttribute('data-variant-id');

        if (!variantId) {
          var form = button.closest('form');
          if (form) {
            var select = form.querySelector('[name="id"]');
            if (select) {
              variantId = select.value;
            }
          }
        }

        if (!variantId) return;

        button.disabled = true;
        button.textContent = 'LOADING...';

        addToCart(parseInt(variantId, 10), getProductQuantity(button))
          .then(function () {
            var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
            window.location.href = root + 'checkout';
          })
          .catch(function (error) {
            console.error('[GP] Checkout failed:', error);
            button.disabled = false;
            button.textContent = 'CHECKOUT';
          });
      });
    });
  }

  /* ---------- Product Page Variant Select ---------- */

  function initProductPageMedia() {
    var mainImg = document.getElementById('product-main-image');
    var thumbsWrap = document.getElementById('product-thumbs');
    var prevBtn = document.getElementById('product-prev');
    var nextBtn = document.getElementById('product-next');
    if (!mainImg) return null;

    var thumbBtns = thumbsWrap ? Array.from(thumbsWrap.querySelectorAll('[data-thumb]')) : [];
    var currentIndex = thumbBtns.findIndex(function (btn) {
      return btn.classList.contains('is-active');
    });
    if (currentIndex < 0) currentIndex = 0;

    function goTo(index) {
      if (!thumbBtns.length) return;
      currentIndex = (index + thumbBtns.length) % thumbBtns.length;
      var btn = thumbBtns[currentIndex];
      var full = btn.getAttribute('data-full');
      if (full) {
        mainImg.src = full;
        mainImg.removeAttribute('srcset');
      }
      thumbBtns.forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
    }

    function goToImageId(imageId) {
      if (!imageId || !thumbBtns.length) return;
      var matchIndex = thumbBtns.findIndex(function (btn) {
        return btn.getAttribute('data-image-id') === String(imageId);
      });
      if (matchIndex >= 0) goTo(matchIndex);
    }

    if (thumbsWrap) {
      thumbsWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-thumb]');
        if (!btn) return;
        currentIndex = thumbBtns.indexOf(btn);
        goTo(currentIndex);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

    return {
      goToImageId: goToImageId,
      setImageSrc: function (src, imageId) {
        if (!src) return;
        mainImg.src = src;
        mainImg.removeAttribute('srcset');
        if (imageId) goToImageId(imageId);
      }
    };
  }

  function initProductPageVariants(media) {
    var wrapper = document.querySelector('[data-product-variants]');
    var dataEl = document.getElementById('product-variant-data');
    if (!wrapper || !dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var variantSelect = wrapper.querySelector('[data-variant-select]');
    var form = wrapper.closest('form');
    var priceEl = document.getElementById('product-price');
    var addButton = form ? form.querySelector('[data-add-to-cart][data-product-form]') : null;
    var checkoutButton = form ? form.querySelector('[data-checkout-now]') : null;
    var optionCount = variants[0] ? variants[0].options.length : 0;
    var selectedOptions = [];

    for (var i = 0; i < optionCount; i++) {
      var select = wrapper.querySelector('[data-option-select][data-option-index="' + i + '"]');
      if (select) {
        selectedOptions[i] = select.value;
      }
    }

    function findVariant() {
      return variants.find(function (variant) {
        return variant.options.every(function (opt, idx) {
          return opt === selectedOptions[idx];
        });
      });
    }

    function updateVariantUI() {
      var variant = findVariant();
      if (!variant) return;

      if (variantSelect) {
        variantSelect.value = String(variant.id);
      }

      if (addButton) {
        addButton.setAttribute('data-variant-id', variant.id);
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available
          ? (addButton.getAttribute('data-label') || 'ADD TO CART')
          : 'SOLD OUT';
      }

      if (checkoutButton) {
        checkoutButton.setAttribute('data-variant-id', variant.id);
        checkoutButton.disabled = !variant.available;
        checkoutButton.style.display = variant.available ? '' : 'none';
      }

      if (priceEl && variant.price_formatted) {
        priceEl.textContent = variant.price_formatted;
      }

      if (media && variant.featured_image) {
        media.setImageSrc(variant.featured_image.src, variant.featured_image.id);
      }
    }

    wrapper.querySelectorAll('[data-option-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var index = parseInt(select.getAttribute('data-option-index'), 10);
        selectedOptions[index] = select.value;
        updateVariantUI();
      });
    });

    updateVariantUI();
  }

  function initVariantSelect() {
    var selects = document.querySelectorAll('[data-variant-select]');
    selects.forEach(function (select) {
      if (select.closest('[data-product-variants]')) return;
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (!form) return;
        var addButton = form.querySelector('[data-add-to-cart][data-product-form]');
        if (addButton) {
          addButton.setAttribute('data-variant-id', select.value);
        }
        var checkoutButton = form.querySelector('[data-checkout-now]');
        if (checkoutButton) {
          checkoutButton.setAttribute('data-variant-id', select.value);
        }
      });
    });
  }

  /* ---------- Click Cursor (closed fist shown briefly on press) ---------- */

  function initClickCursor() {
    var root = document.documentElement;
    var timer = null;

    function endClickCursor() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        root.classList.remove('gp-clicking');
      }, 150);
    }

    document.addEventListener('mousedown', function () {
      if (timer) clearTimeout(timer);
      root.classList.add('gp-clicking');
    });

    /* Keep fist cursor while button is held (click, drag, text select). */
    window.addEventListener('mouseup', endClickCursor);
    window.addEventListener('blur', function () {
      if (timer) clearTimeout(timer);
      root.classList.remove('gp-clicking');
    });
  }

  /* ---------- Brand logo (Safari/WebKit transparent .mov fallback) ---------- */

  /*
   * Safari (macOS + iOS/iPadOS) cannot decode VP9/WebM with an alpha channel,
   * so it must use the HEVC .mov. Chrome/Chromium/Firefox use the WebM.
   * iPadOS Safari reports a Mac UA, so we detect the Apple WebKit vendor and
   * exclude all Chromium/Gecko-based browsers.
   */
  function needsAlphaHevc() {
    var ua = navigator.userAgent;
    var isChromiumOrGecko = /Chrome|Chromium|CriOS|Edg|OPR|Firefox|FxiOS|Android/.test(ua);
    var isAppleWebKit = /Apple/.test(navigator.vendor || '') || /iPhone|iPad|iPod/.test(ua);
    return isAppleWebKit && !isChromiumOrGecko;
  }

  function initBrandLogos() {
    document.querySelectorAll('[data-brand-logo]').forEach(function (video) {
      if (needsAlphaHevc()) {
        var webpSrc = video.getAttribute('data-src-safari');
        if (webpSrc) {
          var img = document.createElement('img');
          img.src = webpSrc;
          img.className = video.className;
          img.classList.add('gp-brand-logo__webp');
          if (video.id) img.id = video.id + '-webp';
          if (video.getAttribute('aria-label')) {
            img.setAttribute('aria-label', video.getAttribute('aria-label'));
          }
          if (video.getAttribute('aria-hidden')) {
            img.setAttribute('aria-hidden', video.getAttribute('aria-hidden'));
          }
          img.onerror = function () {
            img.remove();
            video.style.display = '';
            var movSrc = video.getAttribute('data-src-ios');
            if (!movSrc) return;
            video.src = movSrc;
            var playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(function () {});
            }
          };
          video.style.display = 'none';
          video.setAttribute('aria-hidden', 'true');
          video.parentNode.insertBefore(img, video);
          return;
        }
      }

      var src = video.getAttribute('data-src-default');
      if (!src || video.src === src) return;
      video.src = src;
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function () {});
      }
    });
  }

  function initBrandLogoHover() {
    var video = document.getElementById('hp-brand-video');
    var link = document.getElementById('hp-brand-link');
    if (!video || !link || video.tagName !== 'VIDEO') return;
    link.addEventListener('mouseenter', function () { video.playbackRate = 0.6; });
    link.addEventListener('mouseleave', function () { video.playbackRate = 1; });
  }

  /* ---------- Intro / Loading Screen ---------- */

  var INTRO_SEEN_KEY = 'gp-intro-seen';

  function introAlreadySeen() {
    try {
      return sessionStorage.getItem(INTRO_SEEN_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markIntroSeen() {
    try {
      sessionStorage.setItem(INTRO_SEEN_KEY, '1');
    } catch (e) {}
  }

  function initIntroScreen() {
    var intro = document.getElementById('gp-intro');
    if (!intro) return;

    /* Only show the intro the first time in a browser session. */
    if (introAlreadySeen()) {
      intro.style.display = 'none';
      return;
    }
    markIntroSeen();

    var logoFill = document.getElementById('gp-intro-logo-fill');
    var dismissed = false;
    var rafId  = null;

    var DURATION = 1300; /* ms — steady linear sweep */

    function dismiss() {
      if (dismissed) return;
      dismissed = true;
      if (rafId) cancelAnimationFrame(rafId);
      if (logoFill) logoFill.style.clipPath = 'inset(0 0 0 0)';
      intro.classList.add('is-leaving');
      intro.addEventListener('transitionend', function onEnd(e) {
        if (e.propertyName !== 'opacity') return;
        intro.removeEventListener('transitionend', onEnd);
        intro.style.display = 'none';
        document.body.style.overflow = '';
      });
    }

    var startTime = null;

    function tick(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / DURATION, 1);

      if (logoFill) logoFill.style.clipPath = 'inset(0 ' + ((1 - progress) * 100) + '% 0 0)';

      if (progress < 1) {
        rafId = requestAnimationFrame(tick);
      } else {
        setTimeout(dismiss, 350);
      }
    }

    requestAnimationFrame(tick);

    /* Auto-dismiss safety net */
    setTimeout(dismiss, DURATION + 600);

    /* Click anywhere to skip */
    intro.addEventListener('click', dismiss);

    document.body.style.overflow = 'hidden';
  }

  /* ---------- Scroll footer reveal (mobile: product) ---------- */

  function initScrollFooterReveal() {
    var body = document.body;
    if (!body.classList.contains('template-product')) return;

    var footer = document.querySelector('.site-footer');
    if (!footer || typeof IntersectionObserver === 'undefined') return;

    var mobileMq = window.matchMedia('(max-width: 768px)');

    function setVisible(isVisible) {
      if (!mobileMq.matches) {
        body.classList.remove('is-scroll-footer-visible');
        return;
      }
      body.classList.toggle('is-scroll-footer-visible', isVisible);
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setVisible(entry.isIntersecting);
      });
    }, {
      threshold: 0,
      rootMargin: '0px'
    });

    function bind() {
      observer.disconnect();
      if (!mobileMq.matches) {
        setVisible(false);
        return;
      }
      observer.observe(footer);
    }

    bind();
    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', bind);
    } else if (mobileMq.addListener) {
      mobileMq.addListener(bind);
    }
  }

  /* ---------- Init ---------- */

  document.addEventListener('DOMContentLoaded', function () {
    initBrandLogos();
    initBrandLogoHover();
    updateCartCount();
    initCartQuantity();
    initProductQuantity();
    initProductForms();
    initCheckoutButtons();
    var media = initProductPageMedia();
    initProductPageVariants(media);
    initVariantSelect();
    initClickCursor();
    initIntroScreen();
    initScrollFooterReveal();
  });
})();
